class GestionService {
  constructor() {}
  resources = () => ({
    sectoresPadres: {
      uri: `/v1/sectorespadres`,
      method: ['get']
    },
    bloques: {
      uri: `/v1/unidadcomedor/bloques`,
      method: ['get']
    },
    cultivos: {
      uri: `/v1/unidadcomedor/cultivos`,
      method: ['get']
    },
    etapas: {
      uri: `/v1/unidadcomedor/etapas`,
      method: ['get']
    },
    campos: {
      uri: `/v1/unidadcomedor/campos`,
      method: ['get']
    },
    listar: {
      uri: `/v1/unidadcomedor/listar`,
      method: ['get']
    },
    estado: {
      uri: `/v1/unidadcomedor/cambiarestado`,
      method: ['put']
    }
  });
}

export default GestionService;
